var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipDeckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.64314 0.857422L4.35742 5.14314L8.64314 9.42885",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 14.1436C3.5 15.9236 4.02784 17.6636 5.01677 19.1437C6.00571 20.6237 7.41131 21.7773 9.05585 22.4585C10.7004 23.1397 12.51 23.3179 14.2558 22.9706C16.0016 22.6234 17.6053 21.7662 18.864 20.5075C20.1226 19.2488 20.9798 17.6452 21.3271 15.8994C21.6743 14.1535 21.4961 12.3439 20.8149 10.6994C20.1337 9.05487 18.9802 7.64926 17.5001 6.66033C16.0201 5.6714 14.28 5.14355 12.5 5.14355H4.35714",
    stroke: "#1377D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipDeckIcon);
export default __webpack_public_path__ + "static/media/flip-deck-icon.01c224a4b7d98e955431d90f94f3e7f8.svg";
export { ForwardRef as ReactComponent };